module.exports = __webpack_public_path__ + "static/img/1baoshang.3cf5db3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/1baoshang.jpg
// module id = KQq7
// module chunks = 1 2 3 4 5 6 7 8 9 10